import {
	Environment,
	type EnvironmentConfig,
	type IEnvironment,
	type RelayFieldLogger,
} from 'relay-runtime';

import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';

type Props = {
	log?: EnvironmentConfig['log'];
	requiredFieldLogger?: RelayFieldLogger;
	// ... other <product> dependencies, like error logging, analytics, etc.
	getRequestHeaders?: () => RequestInit['headers']; // TODO: pass it down to the environment config
};

type AtlassianRelayEnvironment = IEnvironment;

export function createRelayEnvironment({
	log,
	requiredFieldLogger,
}: Props): AtlassianRelayEnvironment {
	return new Environment(getDefaultRelayEnvironmentConfig({ log, requiredFieldLogger }));
}

export const AtlassianRelayEnvironment = createRelayEnvironment({});
